import { createContext } from 'react';

interface AppContextType { state: any, dispatch: React.Dispatch<any> };

// set the defaults
const AppContext = createContext<AppContextType>({
    state: {},
    dispatch: () => {}
});

export default AppContext;